import { type Maybe } from '@lingoda/graphql';

export const isLessonLocked = (lesson: Maybe<{ availableWithoutPayment: boolean }>) =>
    !lesson?.availableWithoutPayment;
